import { g_paperType } from "./NcodeSurfaceDataJson";
import { INCH_TO_MM_SCALE, NCODE_TO_INCH_SCALE, PDF_DEFAULT_DPI, UNIT_TO_DPI } from "../constants";
// TODO: 서버에서 nbs를 읽어 오도록 바꾸어야 한다.
export const g_plateDefinitions = {
    "3.161.1": {
        "owner": 1013,
        "pdf_page_count": 2,
        "margin": {
            "Ymax": 49.775295,
            "Xmin": 0,
            "Ymin": 0,
            "Xmax": 88.583336
        },
        "nproj_file": "3_1013_1.nproj",
        "book": 2,
        "pdf_name": "3_1013_1.pdf",
        "section": 3,
        "id": "3.1013.1",
        "ncode_end_page": 2,
        "ncode_start_page": 1
    },
    "3.1013.1": {
        "owner": 1013,
        "pdf_page_count": 2,
        "margin": {
            "Ymax": 49.775295,
            "Xmin": 0,
            "Ymin": 0,
            "Xmax": 88.583336
        },
        "nproj_file": "3_1013_1.nproj",
        "book": 2,
        "pdf_name": "3_1013_1.pdf",
        "section": 3,
        "id": "3.1013.1",
        "ncode_end_page": 2,
        "ncode_start_page": 1
    },
    "3.1013.2": {
        "owner": 1013,
        "pdf_page_count": 2,
        "margin": {
            "Ymax": 49.775295,
            "Xmin": 0,
            "Ymin": 0,
            "Xmax": 88.583336
        },
        "nproj_file": "3_1013_2.nproj",
        "book": 2,
        "pdf_name": "3_1013_2.pdf",
        "section": 3,
        "id": "3.1013.2",
        "ncode_end_page": 2,
        "ncode_start_page": 1
    },
    "3.1013.3": {
        "owner": 1013,
        "pdf_page_count": 60,
        "margin": {
            "Ymax": 113.47024,
            "Xmin": 5.4836307,
            "Ymin": 5.4836307,
            "Xmax": 82.25595
        },
        "nproj_file": "3_1013_3.nproj",
        "book": 3,
        "pdf_name": "3_1013_3.pdf",
        "section": 3,
        "id": "3.1013.3",
        "ncode_end_page": 60,
        "ncode_start_page": 1
    },
};
export const g_controllerDefinitions = {
    "3.1013.1": {
        "owner": 1013,
        "pdf_page_count": 11,
        "margin": {
            "Ymax": 81.68303,
            "Xmin": 4.910714,
            "Ymin": 4.910714,
            "Xmax": 113.31845
        },
        "nproj_file": "note_3_1013_1.nproj",
        "book": 1,
        "pdf_name": "note_3_1013_1.pdf",
        "section": 3,
        "id": "3.1013.1",
        "title": "Controller",
        "ncode_end_page": 11,
        "ncode_start_page": 1
    },
};
/**
 *
 * @param pageInfo
 */
export function isPlatePaper(sobp) {
    if (sobp.section === 3 && sobp.owner === 27 && sobp.book === 161 && sobp.page === 1) {
        return false;
    }
    const key = `${sobp.section}.${sobp.owner}.${sobp.book}`;
    return Object.prototype.hasOwnProperty.call(g_plateDefinitions, key);
}
/**
 *
 * @param coordInfo
 */
export function isPUI(pageInfo) {
    const key = `${pageInfo.section}.${pageInfo.owner}.${pageInfo.book}`;
    let isPui = Object.prototype.hasOwnProperty.call(g_controllerDefinitions, key);
    const { owner, book, page, } = pageInfo;
    // console.log( `isPUI: ${owner}.${book}.${page}`);
    if (owner === 27 && book === 161 && page === 1) {
        isPui = isPui || true;
    }
    if (owner === 1013 && book === 1) {
        // page === 4, Smart plate
        // page === 1, Plate paper
        isPui = isPui || true;
    }
    return isPui;
}
/**
 *
 * @param pageInfo
 * @return paper size in NU
 */
function getNPaperSize_nu(item) {
    let desc = item;
    // IPageSOBP 이면 noteserver item을 가져 온다.
    if (!item || !Object.prototype.hasOwnProperty.call(item, "margin")) {
        const pageInfo = item;
        desc = getNPaperInfo(pageInfo);
    }
    const margin = desc.margin;
    return {
        width: margin.Xmax - margin.Xmin,
        height: margin.Ymax - margin.Ymin
    };
}
function getNPaperSize_dpi(item, dpi) {
    // const { section, owner, book, page } = pageInfo;
    const size = getNPaperSize_nu(item);
    return {
        width: Math.round(size.width * NCODE_TO_INCH_SCALE * dpi),
        height: Math.round(size.height * NCODE_TO_INCH_SCALE * dpi),
    };
}
export function getNPaperSize_pu(item) {
    return getNPaperSize_dpi(item, PDF_DEFAULT_DPI);
}
export function convertNPaperSize_pu(item) {
    return getNPaperSize_dpi(item, PDF_DEFAULT_DPI);
}
export function getMediaSize_pu(mediaType) {
    const { width, height } = mediaType;
    return {
        width: width * INCH_TO_MM_SCALE * PDF_DEFAULT_DPI,
        height: height * INCH_TO_MM_SCALE * PDF_DEFAULT_DPI,
    };
}
/**
 * paper size를 해당 inch 단위로 돌려 준다.
 * @param pageInfo
 */
export function getNPaperInfo(pageInfo) {
    let section = -1, owner = -1, book = -1;
    if (pageInfo
        && pageInfo.section !== undefined
        && pageInfo.owner !== undefined
        && pageInfo.book !== undefined) {
        section = pageInfo.section;
        owner = pageInfo.owner;
        book = pageInfo.book;
    }
    let isDefault = false;
    let key = section.toString() + "." + owner.toString() + "." + book.toString();
    let found = g_paperType.definition[key];
    if (!found) {
        key = g_paperType.defaultKey;
        found = g_paperType.definition[key];
        isDefault = true;
    }
    const desc = Object.assign(Object.assign({}, found), { id: key, pageInfo, glyphData: "", isDefault });
    return desc;
}
export function getSurfaceSize_dpi(size, dpi, isLandscape, padding = 0) {
    /** numerator of converting to INCH */
    const numerator = UNIT_TO_DPI[size.unit];
    const mm_numerator = UNIT_TO_DPI["mm"];
    const ratio = 1.0;
    let width = size.width * ratio * dpi / numerator;
    let height = size.height * ratio * dpi / numerator;
    padding = padding * ratio * dpi / mm_numerator;
    width -= padding;
    height -= padding;
    width = Math.floor(width);
    height = Math.floor(height);
    if (isLandscape) {
        return {
            width: height,
            height: width,
        };
    }
    return {
        width: width,
        height: height,
    };
}
export function getSurfaceSize_px_600dpi(size, isLandscape, padding = 0) {
    return getSurfaceSize_dpi(size, UNIT_TO_DPI["600dpi"], isLandscape, padding);
}
export function getSurfaceSize_inch(size, isLandscape, padding = 0) {
    return getSurfaceSize_dpi(size, 1, isLandscape, padding);
}
export function getSurfaceSize_mm(size, isLandscape, padding = 0) {
    return getSurfaceSize_dpi(size, UNIT_TO_DPI["mm"], isLandscape, padding);
}
export function getSurfaceSize_css(size, isLandscape, padding = 0) {
    return getSurfaceSize_dpi(size, UNIT_TO_DPI["css"], isLandscape, padding);
}
export function getSurfaceSize_pu(size, isLandscape, padding = 0) {
    return getSurfaceSize_dpi(size, UNIT_TO_DPI["pu"], isLandscape, padding);
}
export function isPortrait(size) {
    return size.width < size.height;
}
export function getCssDpi() {
    return UNIT_TO_DPI["css"];
}
//# sourceMappingURL=SurfaceInfo.js.map